<template>
  <div>
    <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2">Carregando...</p>
    </div>
    <div class="main-content" v-else>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Fornecedor</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action>
                <div class="form-row">
                  <div class="form-group col-md-8">
                    <label for="Name">
                      <span class="required">*</span> Nome:
                    </label>
                    <input
                      autocomplete="new-password"
                      type="text"
                      id="Name"
                      class="form-control"
                      v-model="supplier.name"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Status">
                      <span class="required">*</span> Status:
                    </label>
                    <select v-model="supplier.status" class="form-control">
                      <option :value="1">Ativo</option>
                      <option :value="0">Inativo</option>
                    </select>
                  </div>
                </div>
                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>
                <div class="block text-right mb-1">
                  <router-link to="/suppliers" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "supplierAdd",
  data() {
    return {
      pageLoading: true,
      supplier: {
        name: "",
        status: "",
      },
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "suppliers";

      if (self.supplier.id) {
        api += "/" + self.supplier.id;
        self.supplier._method = "PUT";
      }

      axios
        .post(api, self.supplier)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/suppliers");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSupplier: function (id) {
      const self = this;
      return axios
        .get(self.$store.state.api + "suppliers/" + id)
        .then((response) => {
          self.supplier = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  async mounted() {
    const self = this;
    let id = self.$route.params.id;

    self.pageLoading = true;

    try {
      if (id) {
        await self.getSupplier(id);
      }
    } catch (e) {
      console.error(e);
    } finally {
      self.pageLoading = false;
    }
  },
};
</script>
